import { Node, NodeApi } from '@candulabs/craft';

/**
 * returns whether a formStep corresponds to the submit step of a given formNode
 * @param formNode
 * @param formStepNode
 * @returns
 */
export const isASubmitFormStep = (formNode: Node, formStepNode: Node) => {
  const formNodeDescendants = formNode.data.nodes;
  return formNodeDescendants.indexOf(formStepNode.id) === formNodeDescendants.length - 1;
};

/**
 * returns whether a droppedNode is compatible with a target formNode,
 * either because it has no formId yet,
 * either if their formId both match
 * @param formNode
 * @param droppedNode
 * @returns
 */
const isFormIdCompatibleWithFormField = (formNode: Node, droppedNode: Node) => {
  const formStepProps = formNode.data.props;
  return !droppedNode.data.props.formId || formStepProps.formId === droppedNode.data.props.formId;
};

/**
 * returns whether a droppedNode can be dropped into a formStep
 * @param formStepNode
 * @param droppedNode
 * @param helpers
 * @returns
 */
export const canDropFormFieldIntoFormStep = (
  formStepNode: Node,
  droppedNode: Node,
  helpers: (nodeId?: string | undefined) => NodeApi,
) => {
  const formNode = helpers(formStepNode.data.parent).get();
  // we can drop if the FormStep is not the last descendant of the Form/ ie the submit step
  return (
    !isASubmitFormStep(formNode, formStepNode) &&
    isFormIdCompatibleWithFormField(formNode, droppedNode)
  );
};
